import { render, staticRenderFns } from "./CompanyEditDocumentsTab.vue?vue&type=template&id=04808c94"
import script from "./CompanyEditDocumentsTab.vue?vue&type=script&lang=ts"
export * from "./CompanyEditDocumentsTab.vue?vue&type=script&lang=ts"
import style0 from "./CompanyEditDocumentsTab.vue?vue&type=style&index=0&id=04808c94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports